var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['tab-content tab-content-desktop-' + _vm.desktop + ' tab-content-mobile-' + _vm.mobile + ' ' + _vm.activeClass]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }